import { render, staticRenderFns } from "./TrafikCezasiHesapPlaniCreateOrUpdate.vue?vue&type=template&id=b6964cba&"
import script from "./TrafikCezasiHesapPlaniCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./TrafikCezasiHesapPlaniCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports